import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Footer from "../../components/Footer/Footer";
import "./apply-now.scss";
import Navbar from "../../components/Navbar/Navbar";
import PreloaderForm from "../../components/PreloaderForm/PreloaderForm";
import Swal from 'sweetalert2';
// toastify
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";


import config from "../../config";
import UploadJobFiles from "./upload-job-files";

const BASE_URL = config.base_url;



const UPLOAD_URL = `${BASE_URL}api/send-applicant-details`;


const ApplyNow = () => {
  const navigate = useNavigate();
 
  const { id } = useParams();



  return (
    <div>
      <Navbar />
    <div className="my-5">
     <UploadJobFiles />
    </div>
      <Footer />
    </div>
  );
};



export default ApplyNow;
